{
	"need_to_know": {
		"dir": "other",
		"name": "grid-box"
	},
	"hospital": {
		"dir": "other",
		"name": "hospital"
	},
	"business": {
		"dir": "fill",
		"name": "thumbs-up"
	},
	"get_covered_icon": {
		"dir": "other",
		"name": "cap"
	},
	"claim": {
		"dir": "documents",
		"name": "clipboard-2"
	}
}
